const themeConfig = {
  honeycombThemePrefix: 'hcr-theme-',
  honeycombThemes: ['flix', 'flix-dark', 'flix-tvm', 'high-contrast', 'kamil', 'kamil-dark', 'kamil-tvm', 'neptune', 'neptune-dark', 'neptune-tvm']
};

export { themeConfig as default };
